import * as React from "react";
import {Grid} from "@material-ui/core";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import quote from "../../img/quote.png";

interface Props {
    description: string;
    author: string;
}

export const QuoteDashboardComponent: React.FC<Props> = ({description, author}) => (
    <StyledQuote item container direction={"column"} spacing={2} justifyContent={"center"}>
        <Grid item>
            <StyledPDescription>{description}</StyledPDescription>
        </Grid>

        <Grid item>
            <StyledPAuthor>{author}</StyledPAuthor>
        </Grid>
    </StyledQuote>
);

const StyledQuote = styled(Grid)`
  background: ${Colors.lightViolet} url(${quote}) no-repeat;
  background-position: left 10px top 20px;
  border: 1px solid #C2C2C2;
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 20px;
  height: 100%;
`;

const StyledPDescription = styled('p')`
  color: #fff;
  font-size: 1.2rem;
  font-weight: 500;
  font-style: italic;
  margin-top: 1.5rem;
`;

const StyledPAuthor = styled('p')`
  color: ${Colors.extraLightViolet};
  font-weight: 500;
  text-align: right;
`;
